module.exports = __webpack_public_path__ + "static/media/Deg.3582b3cf.mp3";